export type PaymentPeriod =
  'today' | 'yesterday' | 'threeDays' | 'week' | 'month' | 'all' | 'custom';
export type PaymentTimeZone = 'America/Los_Angeles' | 'Europe/Moscow';
export type PaymentRange = { from?: string; to?: string };

export function calendarDate(value: Date, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(value);
  const part = (name: string) => parts.find((p) => p.type === name)!.value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}
function shiftDay(day: string, days: number): string {
  const date = new Date(`${day}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}
function midnight(day: string, timeZone: string): string {
  const target = Date.parse(`${day}T00:00:00Z`);
  let instant = target;
  // Resolve midnight using the offset on that calendar day, not today's offset.
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });
  for (let i = 0; i < 3; i++) {
    const parts = formatter.formatToParts(new Date(instant));
    const n = (name: string) => Number(parts.find((p) => p.type === name)!.value);
    const wallTime = Date.UTC(
      n('year'),
      n('month') - 1,
      n('day'),
      n('hour'),
      n('minute'),
      n('second'),
    );
    instant += target - wallTime;
  }
  return new Date(instant).toISOString();
}
function validDay(day: string) {
  return (
    /^\d{4}-\d{2}-\d{2}$/.test(day) &&
    Number.isFinite(Date.parse(`${day}T00:00:00Z`)) &&
    new Date(`${day}T00:00:00Z`).toISOString().slice(0, 10) === day
  );
}
export function paymentDateRange(
  period: PaymentPeriod,
  timeZone: PaymentTimeZone,
  customFrom: string,
  customTo: string,
  now = new Date(),
): PaymentRange | null {
  if (period === 'all') return {};
  const today = calendarDate(now, timeZone);
  let first = today;
  let last = today;
  if (period === 'custom') {
    if (!validDay(customFrom) || !validDay(customTo) || customFrom > customTo) return null;
    first = customFrom;
    last = customTo;
  } else if (period === 'yesterday') first = last = shiftDay(today, -1);
  else
    first = shiftDay(
      today,
      -(period === 'week' ? 6 : period === 'month' ? 29 : period === 'threeDays' ? 2 : 0),
    );
  return { from: midnight(first, timeZone), to: midnight(shiftDay(last, 1), timeZone) };
}
